var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details-component__content content"},[_c('v-client-table',{staticClass:"mobile-1070",attrs:{"data":_vm.permits,"columns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"receipt_download",fn:function(props){return (props.row.receipt_download)?_c('span',{},[_c('a',{attrs:{"href":props.row.download_link,"target":"_blank"}},[_c('div',{staticClass:"icon-download"})])]):_vm._e()}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f8a9afb","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tenants/kiosk-permits/ui/PermitsList.vue
// module id = 1446
// module chunks = 65